import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
//slices
import { companySelector } from 'slices/company';
//helpers
import { capitalize } from 'helpers';

const LanguageSwitcher = ({ className = '', dataTestId = 'language switcher' }) => {
  const { t, i18n } = useTranslation(['header']);
  const { languages } = useSelector(companySelector);
  const [language, setLanguage] = useState('es');

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
  };

  useEffect(() => {
    const lang = localStorage.getItem('i18nextLng');
    if (languages.some((element) => element.code_iso2.includes(lang)))
      setLanguage(lang);
  }, [localStorage.getItem('i18nextLng')]);


  return (
    <Form.Group controlId="FormDepartment" className={className}>
      <Form.Select
        size="sm"
        onChange={(e) => changeLang(e.target.value)}
        as="select"
        value={language}
        data-testid={dataTestId}
      >
        {languages.map((lan) => (
          <option key={lan.nombre} value={lan.code_iso2}>
            {capitalize(lan.nombre)}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default LanguageSwitcher;
